import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.acupoints');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-acupoints',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.admin.acupoints/view.scss */
/* src/app/page.admin.acupoints/view.scss: no such file or directory */`],
})
export class PageAdminAcupointsComponent implements OnInit {
    public items: any[] = [];
    public total: number = 0;
    public page: number = 1;
    public dump: number = 20;
    public searchText: string = '';
    public meridianFilter: string = '';
    public meridians: string[] = [];

    public showEditor: boolean = false;
    public editItem: any = {};

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.loadMeridians();
        await this.load();
        await this.service.render();
    }

    public async loadMeridians() {
        const { code, data } = await wiz.call('meridians');
        if (code === 200) this.meridians = data;
    }

    public async load(page: number = 1) {
        this.page = page;
        const { code, data } = await wiz.call('search', {
            text: this.searchText, page: this.page, dump: this.dump, meridian: this.meridianFilter
        });
        if (code === 200) {
            this.items = data.rows || [];
            this.total = data.total || 0;
        }
        await this.service.render();
    }

    public get totalPages() { return Math.ceil(this.total / this.dump); }
    public get pages() {
        const arr = []; const s = Math.max(1, this.page - 2); const e = Math.min(this.totalPages, s + 4);
        for (let i = s; i <= e; i++) arr.push(i); return arr;
    }

    public openNew() {
        this.editItem = { code: '', name: '', meridian: '', location: '', depth: '', indication: '', body_region: '', is_commonly_used: false };
        this.showEditor = true; this.service.render();
    }

    public async openEdit(item: any) {
        const { code, data } = await wiz.call('get', { id: item.id });
        if (code === 200) { this.editItem = data; this.showEditor = true; await this.service.render(); }
    }

    public closeEditor() { this.showEditor = false; this.service.render(); }

    public async saveItem() {
        const { code, data } = await wiz.call('save', this.editItem);
        if (code === 200) { this.closeEditor(); await this.load(this.page); }
        else { await this.service.modal.show({ title: '오류', message: data.message || '저장 실패', action: '확인' }); }
    }
}

export default PageAdminAcupointsComponent;